import { Suspense, lazy } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Router as ReactRouter, Route, Switch, Redirect } from 'react-router-dom';
import AppContainer from 'FormsUI/components/AppContainer';

// @ts-expect-error no types
import FormsDashboard from 'FormsUI/components/dashboard/FormsDashboardContainer';
const FormsEditorWrapper = /*#__PURE__*/lazy(
// @ts-expect-error untyped dependency
() => import('FormsUI/components/editor/FormsEditorWrapper'));
const TemplatesContainer = /*#__PURE__*/lazy(() => import('FormsUI/components/templates/TemplatesContainer'));
const FormTypePanelContainer = /*#__PURE__*/lazy(
// @ts-expect-error untyped dependency
() => import('FormsUI/components/dashboard/panels/FormTypePanelContainer'));
const ComparisonToolRoute = /*#__PURE__*/lazy(() => import('FormsUI/ComparisonToolRoute'));
import PersistentFullScreenWrapper from 'FormsUI/components/PersistentFullScreenWrapper';
import { Tabs } from 'FormsUI/constants/Submissions';
// @ts-expect-error no types
import RedirectLeadFlowsDetails from 'FormsUI/router/RedirectLeadFlowsDetails';
import RedirectToSubmissions from 'FormsUI/router/RedirectToSubmissions';
import RedirectToDashboard from 'FormsUI/router/RedirectToDashboard';
import { isUngatedForRedirectToNewDashboardApp } from 'FormsUI/selectors/Gates';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const withNewDashboardAppRedirect = (Component, path) => () => {
  const ungatedForNewDashboardAppRedirect = useSelector(isUngatedForRedirectToNewDashboardApp);
  if (ungatedForNewDashboardAppRedirect) {
    return /*#__PURE__*/_jsx(RedirectToDashboard, {
      path: path
    });
  }
  return /*#__PURE__*/_jsx(Component, {});
};
const StepFormsEditor = () => router => {
  const {
    formGuid,
    step
  } = router.match.params;
  const pathParams = {
    formGuid,
    step,
    selectedFormItem: decodeURIComponent(window.location.href).split('?')[0].split('field/')[1]
  };
  return /*#__PURE__*/_jsx(FormsEditorWrapper, Object.assign({}, router, pathParams));
};
const SubmissionsRoute = tab => router => {
  const {
    conversionId,
    formGuid
  } = router.match.params;
  const pathParams = {
    conversionId,
    tab,
    formGuid
  };
  return /*#__PURE__*/_jsx(RedirectToSubmissions, Object.assign({}, router, pathParams));
};
const ParentFormsDashboard = tab => router => /*#__PURE__*/_jsx(FormsDashboard, Object.assign({}, router, {
  tab: tab
}));
const ComparisonToolWrapper = () => router => /*#__PURE__*/_jsx(ComparisonToolRoute, Object.assign({}, router));
const BaseDashboardComponent = withNewDashboardAppRedirect(ParentFormsDashboard('manage'), '/');
const ViewComponent = withNewDashboardAppRedirect(ParentFormsDashboard('manage'), '/views/:viewId');
const FoldersComponent = withNewDashboardAppRedirect(ParentFormsDashboard('manage'), '/folders');
const ManageComponent = withNewDashboardAppRedirect(ParentFormsDashboard('manage'), '/manage');
const AnalyzeComponent = withNewDashboardAppRedirect(ParentFormsDashboard('analyze'), '/analyze');
const CompareComponent = withNewDashboardAppRedirect(ComparisonToolWrapper(), '/compare');
const TemplatesComponent = withNewDashboardAppRedirect(TemplatesContainer, '/templates');
const TypeComponent = withNewDashboardAppRedirect(FormTypePanelContainer, '/type');
const TypeExperimentComponent = withNewDashboardAppRedirect(FormTypePanelContainer, '/type-experiment');

// Additional props (handled by AppContainer):
// - [screen] tells the analytics tracker what screen the user is on.
// - [subscreen] tells that analytics tracker what subscreen the user is on.
const Router = ({
  history
}) => {
  return /*#__PURE__*/_jsx(ReactRouter, {
    history: history,
    children: /*#__PURE__*/_jsx(AppContainer, {
      children: /*#__PURE__*/_jsxs(Suspense, {
        fallback: /*#__PURE__*/_jsx(LoadingOverlay, {
          contextual: true
        }),
        children: [/*#__PURE__*/_jsxs(Switch, {
          children: [/*#__PURE__*/_jsx(Route, {
            exact: true,
            path: "/forms/:portalId/",
            component: BaseDashboardComponent
          }), /*#__PURE__*/_jsx(Route, {
            exact: true,
            path: "/forms/:portalId/views/:viewId",
            component: ViewComponent
          }), /*#__PURE__*/_jsx(Route, {
            exact: true,
            path: "/forms/:portalId/folders",
            component: FoldersComponent
          }), /*#__PURE__*/_jsx(Route, {
            exact: true,
            path: "/forms/:portalId/manage",
            component: ManageComponent
          }), /*#__PURE__*/_jsx(Route, {
            exact: true,
            path: "/forms/:portalId/analyze",
            component: AnalyzeComponent
          }), /*#__PURE__*/_jsx(Route, {
            exact: true,
            path: "/forms/:portalId/compare",
            component: CompareComponent
          })]
        }), /*#__PURE__*/_jsx(Route, {
          component: PersistentFullScreenWrapper,
          children: /*#__PURE__*/_jsxs(Switch, {
            children: [/*#__PURE__*/_jsx(Route, {
              path: "/forms/:portalId/templates"
              // @ts-expect-error its fine
              ,
              screen: "templates",
              component: TemplatesComponent
            }), /*#__PURE__*/_jsx(Route, {
              path: "/forms/:portalId/type"
              // @ts-expect-error its fine
              ,
              screen: "type",
              component: TypeComponent
            }), /*#__PURE__*/_jsx(Route, {
              path: "/forms/:portalId/type-experiment"
              // @ts-expect-error its fine
              ,
              screen: "type",
              component: TypeExperimentComponent
            }), /*#__PURE__*/_jsx(Redirect, {
              exact: true,
              from: "/forms/:portalId/:formGuid/edit",
              to: "/forms/:portalId/editor/:formGuid/edit/form"
            }), /*#__PURE__*/_jsx(Redirect, {
              exact: true,
              from: "/forms/:portalId/:formGuid/edit/:step",
              to: "/forms/:portalId/editor/:formGuid/edit/:step"
            }), /*#__PURE__*/_jsx(Route, {
              path: "/forms/:portalId/editor/:formGuid/edit/:step",
              component: StepFormsEditor()
            }), /*#__PURE__*/_jsx(Redirect, {
              exact: true,
              from: "/forms/:portalId/editor/:formGuid",
              to: "/forms/:portalId/editor/:formGuid/edit/form"
            }), /*#__PURE__*/_jsx(Redirect, {
              exact: true,
              from: "/forms/:portalId/editor/:formGuid/:corruptedPath",
              to: "/forms/:portalId/editor/:formGuid/edit/form"
            })]
          })
        }), /*#__PURE__*/_jsxs(Switch, {
          children: [/*#__PURE__*/_jsx(Route, {
            exact: true,
            path: "/forms/:portalId/:formGuid/performance",
            component: SubmissionsRoute(Tabs.PERFORMANCE)
          }), /*#__PURE__*/_jsx(Route, {
            exact: true,
            path: "/forms/:portalId/:formGuid/analyze",
            component: SubmissionsRoute(Tabs.ANSWERS)
          }), /*#__PURE__*/_jsx(Route, {
            exact: true,
            path: "/forms/:portalId/:formGuid/submissions",
            component: SubmissionsRoute(Tabs.SUBMISSIONS)
          }), /*#__PURE__*/_jsx(Route, {
            exact: true,
            path: "/forms/:portalId/:formGuid/submissions/:conversionId",
            component: SubmissionsRoute(Tabs.SUBMISSIONS)
          })]
        }), /*#__PURE__*/_jsx(Route, {
          exact: true,
          path: "redirect/lead-flows/details/:leadFlowId",
          component: RedirectLeadFlowsDetails
        })]
      })
    })
  });
};
Router.propTypes = {
  history: PropTypes.object.isRequired
};
export default Router;